import Link from "next/link";
import { FiChevronRight } from "react-icons/fi";

//local imports
import classes from "@/styles/document-toolkit/document-toolkit-main.module.css";
import { documentToolKit } from "@/utils/content";

export default function DocumentToolKitMain() {
  const content = documentToolKit.en;

  return (
    <div className={classes.container}>
      <section className={`${classes.hero}`}>
        <h1 className="text-center">{content.title}</h1>
      </section>
      <section className="my-5 container">
        <ul className={classes.card}>
          {content.list?.map((l, i) => {
            const length = content.list.length;
            return (
              <li className={length === i + 1 ? "" : "border-bottom"} key={i}>
                <Link className="text-black" href={l.url} target="_blank">
                  {l.title}
                  <span>
                    <FiChevronRight className="float-end" size={20} />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
